import { StylesObject } from '../../types/styles'
import { SITE_VARIABLES, mq } from '../../themes/variables'

export interface RankStylesObject extends StylesObject {
    root: StylesObject
    contentWrapper: StylesObject
    innerContent: StylesObject
    headerIcon: StylesObject
    headerWrapper: StylesObject
    header: StylesObject
    metaText: StylesObject
    divider: StylesObject
    logo: StylesObject
    buttonContainer: StylesObject
    button: StylesObject
    first: StylesObject
    second: StylesObject
}

export const getDefaultRankStylesObj = (
    siteVars: typeof SITE_VARIABLES,
    preview: boolean | undefined,
): RankStylesObject => {
    const { COLORS, CSS_SELECTORS, TEXT_FONT_FAMILY, FONT_SIZE } = siteVars

    return {
        root: {
            margin: '1.5rem 0',
            borderTop: `0.25rem solid ${COLORS.GRAY}`,
            paddingTop: '1rem',
            ...(!preview && {
                [mq[1]]: {
                    margin: '2rem 0',
                },
            }),
            ...(!preview && {
                [mq[2]]: {
                    display: 'flex',
                    justifyContent: 'space-between',
                },
            }),
        },
        contentWrapper: {
            display: 'flex',
            ...(!preview && {
                [mq[2]]: {
                    alignItems: 'center',
                    flex: '1',
                },
            }),
        },
        center: {
            alignItems: 'center',
        },
        innerContent: {
            paddingBottom: '1rem',
            color: COLORS.MEDIUMGRAY,
            borderBottom: `0.25rem solid ${COLORS.GRAY}`,
        },
        headerIcon: {
            fontFamily: TEXT_FONT_FAMILY.DEFAULT,
            fontSize: '1.2rem',
            fontWeight: '800',
            position: 'relative',
            display: 'flex',
            alignItems: 'center',
            flex: '0 0 3rem',
            justifyContent: 'center',
            height: '3rem',
            marginRight: '1rem',
            color: COLORS.WHITE,
            backgroundSize: 'cover',
            '& *': {
                position: 'absolute',
            },
            ...(!preview && {
                [mq[2]]: {
                    flex: '0 0 3.5rem',
                    width: '4rem',
                    height: '4rem',
                },
            }),
        },
        headerWrapper: {
            fontFamily: TEXT_FONT_FAMILY.DEFAULT,
            flex: '1 1 auto',
            textAlign: 'center',
            ...(!preview && {
                [mq[2]]: {
                    textAlign: 'left',
                },
            }),
        },
        header: {
            ...FONT_SIZE.H1,
            margin: '0',
            textTransform: 'capitalize',
        },
        metaText: {
            ...FONT_SIZE.H3,
            fontWeight: '800',
            lineHeight: '1.2',
            marginTop: '0.2rem',
            color: COLORS.DARKGRAY,
        },
        divider: {
            fontWeight: '300',
        },
        logo: {
            display: 'flex',
            flex: '0 0 3rem',

            marginLeft: '1rem',
            ...(!preview && {
                [mq[2]]: {
                    flex: '0 0 3.5rem',
                },
            }),
            img: {
                width: '3rem',
                height: '3rem',
                ...(!preview && {
                    [mq[2]]: {
                        width: '3.5rem',
                        height: '3.5rem',
                    },
                }),
            },
        },
        buttonContainer: {
            display: 'flex',
            margin: '1rem 0',
            justifyContent: 'center',
            ...(!preview && {
                [mq[2]]: {
                    flexDirection: 'column',
                    margin: '0 0 0 1rem',
                },
            }),
        },
        button: {
            fontFamily: TEXT_FONT_FAMILY.DEFAULT,
            fontSize: '0.7rem',
            fontWeight: '800',
            flex: '1',
            padding: '0.4rem 1rem',
            textAlign: 'center',
            textTransform: 'uppercase',
            color: COLORS.WHITE,
            borderRadius: '2.2rem',
            backgroundColor: COLORS.DARK,
            textDecoration: 'none',
            ...(!preview && {
                [mq[2]]: {
                    flex: '0 1',
                },
            }),
            [CSS_SELECTORS.HOVER]: {
                color: COLORS.LIGHT,
            },
        },
        first: {
            marginRight: '0.25rem',
            ...(!preview && {
                [mq[2]]: {
                    marginRight: '0',
                },
            }),
        },
        second: {
            marginLeft: '0.25rem',
            ...(!preview && {
                [mq[2]]: {
                    marginTop: '0.5rem',
                    marginLeft: '0',
                },
            }),
        },
    }
}
